import styled, { StyledProps } from 'styled-components/macro';

export type CreateStylesProps = StyledProps<{
  size?: string;
}>;

export const Create = styled.div<CreateStylesProps>`
  flex: 1;
  margin-bottom: 100px;
`;

const sizes: any = {
  lg: '270px',
  md: '153px',
  sm: '100px',
};

export const Controls = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 20px;

  & > * {
    margin-right: 16px;
    margin-bottom: 0;
  }

  & > div {
    span {
      margin-bottom: 6px !important;
    }
  }
`;

export const FormGroupItem = styled.div<CreateStylesProps>`
  width: ${(props) => (props.size ? sizes[props.size] : '100%')};
  margin-right: 10px;
`;

export const FormGroup = styled.div`
  display: flex;
`;

export const Title = styled.div`
  color: #333333;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
`;

export const Period = styled.div`
  background: #e9edf1;
  padding: 20px;
  display: flex;
  margin: 5px 0 10px 0;
`;

export const PeriodItem = styled.div`
  margin-right: 95px;
`;

export const RadioButtons = styled.div`
  display: flex;
  margin: 12px 0 20px 0;
`;

export const RadioButtonsItem = styled.div`
  width: 100px;
`;

export const Separator = styled.div`
  border-top: 1px solid #bcc3ca;
  padding: 5px 0;
`;

export const Text = styled.div`
  font-size: 12px;
  line-height: 15px;
  color: #333333;
`;
